export default [
	{
		path: "/pros/reports",
		exact: true,
		policy: "providerAuth",
		component: "Reports",
		mui: true,
	},
];
